import { getDisplayNameFromSelectboxItem } from '@/alert/utils/utils';
import { getDuringTimeItems, getEvaluateValueItems } from '@/alert/utils/define';

export const DEFAULT_METRIC_DURING_TIME_INTERVAL = 'p5m';

export type ThresholdIntervalSource = {
  evaluateValue?: string;
  duringTimeInterval?: string;
};

/**
 * 메트릭 임계치 표시용 duringTimeInterval 키 해석.
 * - API/룰 저장값 우선
 * - avg 등: 없으면 기본 p5m
 * - current(실시간): 저장 시 비워져도 상세 표시용 기본 p5m
 * - changePerSec: 구간 미사용
 */
export const resolveDuringTimeIntervalKey = (
  threshold: ThresholdIntervalSource,
  ruleThreshold?: ThresholdIntervalSource,
): string | undefined => {
  const stored = threshold.duringTimeInterval ?? ruleThreshold?.duringTimeInterval;
  if (stored) {
    return stored;
  }

  const evaluateKey = threshold.evaluateValue ?? ruleThreshold?.evaluateValue;
  if (!evaluateKey || evaluateKey === 'changePerSec') {
    return undefined;
  }

  return DEFAULT_METRIC_DURING_TIME_INTERVAL;
};

/** AlertRuleCard 임계치 행: [집계방식, during the 라벨, 구간 라벨] */
export const buildThresholdEvaluateValueParts = (
  evaluateValue: string | undefined,
  duringTimeInterval: string | undefined,
  duringTheLabel: string,
): string[] => {
  const evaluateLabel = evaluateValue
    ? getDisplayNameFromSelectboxItem(getEvaluateValueItems(), evaluateValue, 'evaluate')
    : '';
  const duringKey = resolveDuringTimeIntervalKey({ evaluateValue, duringTimeInterval });
  const duringIntervalLabel = duringKey
    ? getDisplayNameFromSelectboxItem(getDuringTimeItems(), duringKey)
    : '';

  return [evaluateLabel, duringTheLabel, duringIntervalLabel];
};
